export default "__VITE_ASSET__CPCOm$XZ__"